import DefaultBanner from '../DefaultBanner/index'
import {
    getNetstat,
    getVideoPath,
    onNetstatChanged,
} from '../../../../api/index'
import VideoPlayer from '../../../component/VideoPlayer'

const VIDEO_PLAY_MODE = {
    PLAY_ON_WIFI: 1, //wifi下自动播放
    PLAY_ON_CLICK: 2, //点击后播放
    PLAY_ON_CAN_PLAY: 3, //有网络就自动播放（默认）
}

const NETSTAT = {
    OFF_LINE: 0,    //无网络
    UNKNOW: 1,      //unknown
    NET_2G: 2,      // 2G
    NET_3G: 3,      // 3G
    NET_4G: 4,      // 4G
    NET_WIFI: 9     //WIFI
}
export default class VideoBanner extends DefaultBanner {
    constructor(props) {
        super(props)
        //this.campaign = props.campaign || {}
        this.netstat = NETSTAT.UNKNOW
        try{
            const autoPlaySetting = this.unit.setting.autoplay
            console.log('autoPlaySetting ====>' , this.unit, this.unit.setting.autoplay)
            this.videoPlayMode = autoPlaySetting || VIDEO_PLAY_MODE.PLAY_ON_CAN_PLAY
        }catch(e){
            this.videoPlayMode = VIDEO_PLAY_MODE.PLAY_ON_CAN_PLAY
        }
        console.log('default autoPlay value ====> videoPlayMode:' , this.videoPlayMode)
    }

    adShowed(res) {
        super.adShowed(res)
        this.checkPlay()
    }

    init(){
        super.init()

        getNetstat().then((res)=>{
            console.log('getNetstat：：：：：========》',res)
            const { netstat } = res
            this.netstat = netstat===0 ? netstat : (netstat|| NETSTAT.UNKNOW)
        })

        onNetstatChanged(res=>{
            console.log('onNetstatChanged：：：：：========》',res)
            const { netstat } = res
            this.netstat = netstat===0 ? netstat : (netstat|| NETSTAT.UNKNOW)
        })
    }

    bindPageEvent() {
        super.bindPageEvent()
        if(this.videoPlayer){
            this.videoPlayer.onVideoClick((e)=>{
                console.log('do ------- click',e.currentTarget || e.target, this.videoPlayer, this.videoPlayer.paused , this.videoPlayer.ended)

                if(this.videoPlayer.paused || this.videoPlayer.ended){
                    console.log('视频被点击：：：：：==========》this.videoPlayer.paused='+this.videoPlayer.paused+' this.videoPlayer.ended='+this.videoPlayer.ended)

                    //视频加载出错时则不播放 会默认进行跳转
                    if(!this.videoPlayer.loadError){
                        this.videoPlayer.play()
                        e.stopPropagation()
                    }else{
                        console.log('视频load error， 跳转：：：：：========》this.videoPlayer.paused='+this.videoPlayer.paused+' this.videoPlayer.ended='+this.videoPlayer.ended)
                    }
                }else{
                    //跳转
                    console.log('点击视频跳转：：：：：========》this.videoPlayer.paused='+this.videoPlayer.paused+' this.videoPlayer.ended='+this.videoPlayer.ended)
                }
            })

            //视频加载出错时进行标记
            this.videoPlayer.onLoadError((e)=>{
                this.videoPlayer.loadError = true
            })
        }
    }

    /**
     * 绑定native组件各个事件
     */
    bindNativeEvent() {
        super.bindNativeEvent()
        this.registerNativeSetVideoPlayMode((params={}, resolve, reject)=>{
            console.log('触发videoPlayMode事件', params)
            const { autoPlay } = params
            const enumList =[
                VIDEO_PLAY_MODE.PLAY_ON_WIFI,
                VIDEO_PLAY_MODE.PLAY_ON_CLICK,
                VIDEO_PLAY_MODE.PLAY_ON_CAN_PLAY
            ]
            if(enumList.indexOf(autoPlay) !== -1){
                this.videoPlayMode = autoPlay
            }else{
                console.log('autoPlay参数错误：', autoPlay,enumList)
            }
        })
    }

    /**
     * 视图被展示
     */
    viewAppeared(){
        this.checkPlay()
    }

    /**
     * 视图被隐藏
     */
    viewDisappeared(){
        this.videoPlayer && this.videoPlayer.pause()
    }

    initComponents(){
        super.initComponents()
        const videoEle = document.getElementById("adVideo")
        console.log('adVideo ====> ', videoEle)
        if(videoEle){
            console.log('初始化 this.videoPlayer ====> ', videoEle)
            this.videoPlayer = new VideoPlayer({
                videoProgressWrap:document.getElementById("videoProgressWrap"),
                btnMuted:document.getElementById("btnMuted"),
                btnPlay:document.getElementById("btnPlay"),
                videoEle,
                progressBar:document.getElementById("videoProgress"),
                muted:true,
                autoplay:false,
            });


            videoEle.addEventListener('loadstart', (e)=>{
                console.log('video-event: loadstart 客户端开始请求数据', e)
            },false)
            videoEle.addEventListener('progress', (e)=>{
                console.log('video-event: progress 客户端正在请求数据', e)
            },false)
            videoEle.addEventListener('abort', (e)=>{
                console.log('video-event: abort 客户端主动终止下载（不是因为错误引起）', e)
            },false)
            videoEle.addEventListener('loadedmetadata', (e)=>{
                console.log('video-event: loadedmetadata', e)
            },false)
            videoEle.addEventListener('stalled', (e)=>{
                console.log('video-event: stalled 网速失速', e)
            },false)
            videoEle.addEventListener('waiting', (e)=>{
                console.log('video-event: waiting 等待数据，并非错误', e)
            },false);


            (()=>{
                const videoEle = document.getElementById("adVideo")
                videoEle.addEventListener('canplay', (e)=>{
                    console.log('video-event: canplay', e)
                    console.log("viewHasAppeared",this.viewHasAppeared)
                    console.log("hasShowed",this.hasShowed)
                    if(this.hasShowed || this.viewHasAppeared){
                        this.checkPlay()
                    }
                },false)
                let fnList = [()=>{
                    const videoURL = this.campaign.video_url_decode || this.campaign.video_url
                    const videoCacheKey = this.campaign.video_url
                    getVideoPath({
                        unitId: this.unit.id,
                        ref: videoCacheKey
                    }).then(res=>{
                        const { resource=[] } = res
                        const resourceItem = resource[0] || {}
                        const URLItem = resourceItem[videoCacheKey] || {}
                        const isCompleted = URLItem.downloaded // 1：sdk下载成功  2：sdk未下载完成
                        const path = URLItem.path4Web
                        console.log('video_url===>>>:', path, isCompleted, path, videoURL)
                        if(isCompleted === 1 || isCompleted === '1'){
                            videoEle.src = path
                        }else{
                            videoEle.src = videoURL
                        }
                        console.log("sdk download video，重新检测是否play")
                        console.log("viewHasAppeared",this.viewHasAppeared)
                        console.log("hasShowed",this.hasShowed)
                        if(this.hasShowed || this.viewHasAppeared){
                            this.checkPlay()
                        }
                    })
                }, ()=>{
                    const videoURL = this.campaign.video_url_decode
                    videoURL && (videoEle.src = videoURL)
                }]

                videoEle.addEventListener('error', (e)=>{
                    console.log('video-event: error 请求数据时遇到错误', e, fnList.length)
                    const fn = fnList.shift()
                    fn && fn()
                },false)
            })()

        }

    }

    checkPlay(){
        if(!this.videoPlayer){
            return
        }
        console.log('checkPlay========》this.netstat',this.netstat,"this.videoPlayMode", this.videoPlayMode, "this.videoPlayer",this.videoPlayer)
        switch(this.videoPlayMode){
            case VIDEO_PLAY_MODE.PLAY_ON_WIFI :
                //如果是wifi网络
                if(this.netstat === NETSTAT.NET_WIFI){
                    this.videoPlayer.play()
                }
                break
            case VIDEO_PLAY_MODE.PLAY_ON_CLICK :
                break
            case VIDEO_PLAY_MODE.PLAY_ON_CAN_PLAY :
                //如果有网络
                if(this.netstat !== NETSTAT.OFF_LINE && this.netstat !== NETSTAT.UNKNOW){
                    this.videoPlayer.play()
                }
                break
        }
    }
}